export const MANHATTAN_ZIP = /^10[0-2]\d\d$/;

export const zipStatus = (zip) => {
  if (!/^\d{5}$/.test(zip)) return "incomplete";
  return MANHATTAN_ZIP.test(zip) ? "manhattan" : "outside";
};

export const visitDates = (count = 14) => {
  const out = [];
  const d = new Date();
  d.setDate(d.getDate() + 2);
  while (out.length < count) {
    out.push(new Date(d));
    d.setDate(d.getDate() + 1);
  }
  return out;
};

export const WINDOWS = [
  { id: "morning", label: "Morning" },
  { id: "midday", label: "Midday" },
  { id: "afternoon", label: "Afternoon" },
];

export const fmtDate = (d, opts = { weekday: "short", month: "short", day: "numeric" }) =>
  new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", ...opts }).format(d);

export const dateKey = (d) => new Intl.DateTimeFormat("en-CA", { timeZone: "America/New_York" }).format(d);

export const STEPS = ["Your assessment", "Add-ons", "Scheduling", "Your details", "Payment"];

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const PHONE_RE = /^\+?1?[\s.-]?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export const validateDetails = (d) => {
  const e = {};
  if (!d.name.trim() || d.name.trim().length < 2) e.name = "Enter your full name.";
  if (!EMAIL_RE.test(d.email.trim())) e.email = "Enter a valid email address.";
  if (!PHONE_RE.test(d.phone.trim())) e.phone = "Enter a valid US phone number, e.g. (212) 555-0142.";
  if (!d.address.trim() || d.address.trim().length < 4) e.address = "Enter your street address.";
  return e;
};
